import * as React from "react";

/**
 * True while a page-level transition is in flight (capture + fade not done).
 * Components on either side of the swap (incoming /decks, outgoing /decks)
 * can subscribe via useContext to freeze their own per-frame animations so
 * the snapshot/live overlap doesn't show scroll-driven scale ramping.
 */
export const PageTransitionContext = React.createContext<{
  isTransitioningRef: React.MutableRefObject<boolean>;
}>({
  isTransitioningRef: { current: false },
});
